import React from 'react';
import { HomeContent_Root, HomeContent_TrackingHeader, HomeContent_SearchBar, HomeContent_Message } from './HomeContent.style';
import { searchCallback } from '../../utilities/searchCallback';

/**
 * @typedef HomeContentProps
 * @property {React.ReactNode} [message] The message to be shown on events.
 */

/** @type {(props: HomeContentProps & React.HTMLAttributes<HTMLAnchorElement>) => JSX.Element} */
export const HomeContent = (props) => {
    const {
        message = ''
    } = props;

    return (
        <HomeContent_Root>
            <HomeContent_TrackingHeader>Track your freight</HomeContent_TrackingHeader>
            {message ? (
                <HomeContent_Message>
                    {message}
                </HomeContent_Message>
            )
                : null
            }
            <HomeContent_SearchBar searchCallback={searchCallback} />
            {process.env.FORWARDER === 'Navegate' && <img alt='RWTS-Track' src='https://staticnavegatecom.blob.core.windows.net/static/images/navegate/RWTS-Track-powered-by-Navgate.png' />}
        </HomeContent_Root>
    );
};
